// Copyright (c) 2024 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted

/**
 * Location audit log page component.
 * Displays the audit history for a specific location.
 */
import { HardfinTabCardWrapper } from '@/components/hardfin-tab-card-wrapper';
import { LocationErrorBoundary } from '@/location/components/location-error-boundary';
import { SiteAuditList } from '@/location/components/site-audit-list';
import { Stack } from '@mui/material';
import { createFileRoute } from '@tanstack/react-router';
import { Suspense } from 'react';

export const Route = createFileRoute('/_app/locations/$locationKey/audit')({
  component: LocationAuditRoute,
});

function LocationAuditRoute() {
  const { locationKey } = Route.useParams();

  return (
    <LocationErrorBoundary>
      <LocationAuditContent locationKey={locationKey} />
    </LocationErrorBoundary>
  );
}

function LocationAuditContent(props: { locationKey: string }) {
  return (
    <HardfinTabCardWrapper title="Audit log">
      <Stack paddingTop={2}>
        <Suspense>
          <SiteAuditList siteKey={props.locationKey} />
        </Suspense>
      </Stack>
    </HardfinTabCardWrapper>
  );
}
